import api from '../lib/api';
import { Staff, CreateStaffForm, UpdateStaffForm, UpdateStaffProfileForm, PaginatedResponse } from '../types';

export const staffService = {
  // Get all staff for a shop
  async getStaffByShop(
    shopId: number, 
    params: {
      page?: number;
      limit?: number;
      search?: string;
      status?: string;
      role?: string;
      sort_by?: string;
      sort_order?: 'asc' | 'desc';
    } = {}
  ): Promise<PaginatedResponse<Staff>> {
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.search) queryParams.append('search', params.search);
    if (params.status) queryParams.append('status', params.status);
    if (params.role) queryParams.append('role', params.role);
    if (params.sort_by) queryParams.append('sort_by', params.sort_by);
    if (params.sort_order) queryParams.append('sort_order', params.sort_order);

    const response = await api.get(`/staff/shop/${shopId}?${queryParams.toString()}`);
    return response.data;
  },

  // Get staff member by ID
  async getStaffById(id: number): Promise<Staff> {
    const response = await api.get(`/staff/${id}`);
    return response.data.data;
  },

  // Create new staff member
  async createStaff(staffData: CreateStaffForm): Promise<Staff> {
    const response = await api.post('/staff', staffData);
    return response.data.data;
  },

  // Update staff member
  async updateStaff(id: number, staffData: UpdateStaffForm): Promise<Staff> {
    const response = await api.put(`/staff/${id}`, staffData);
    return response.data.data;
  },

  // Delete staff member
  async deleteStaff(id: number): Promise<void> {
    await api.delete(`/staff/${id}`);
  },

  // Add tags to staff
  async addStaffTags(staffId: number, tagIds: number[]): Promise<{ success: boolean; message: string }> {
    const response = await api.post(`/staff/${staffId}/tags`, { tag_ids: tagIds });
    return response.data;
  },

  // Remove tag from staff
  async removeStaffTag(staffId: number, tagId: number): Promise<{ success: boolean; message: string }> {
    const response = await api.delete(`/staff/${staffId}/tags/${tagId}`);
    return response.data;
  },

  // Get current staff profile
  async getMyProfile(): Promise<Staff> {
    const response = await api.get('/staff/profile/me');
    return response.data.data;
  },

  // Update current staff profile
  async updateMyProfile(profileData: UpdateStaffProfileForm): Promise<Staff> {
    const response = await api.put('/staff/profile/me', profileData);
    return response.data.data;
  },

  // Get staff statistics for dashboard
  async getStaffStats(shopId: number): Promise<{
    total_staff: number;
    active_staff: number;
    inactive_staff: number;
    admin_count: number;
    manager_count: number;
    staff_count: number;
  }> {
    const response = await api.get(`/staff/shop/${shopId}/stats`);
    return response.data.data;
  }
};
